// Shared land-navigation format and admission policy (taxgw-2ybg B1): the ONE version and the ONE set of budgets
// the offline baker (tools/data/navigation/*.mjs), the content decoder (src/navigation.ts) and the runtime setup
// producer (sim/world/views.ts) all read. Pure policy: no imports, no JSON, no ECS, so the Node data tool can
// import it through @taxwar/content/geometry/navigation-format without booting the content barrel.
//
// The bake-time budgets bound the global offline document; the match-time budgets bound one war's aggregate
// projected physical links and its complete setup DTO. A breach fails with the cause and how to repair it; nothing
// is truncated or silently raised. These are design/source-reviewed limits, not measured runtime capacity.

/** Version of the serialized land-navigation document; the decoder rejects any other. Baked format stays 1. */
export const NAVIGATION_FORMAT_VERSION = 1

/** Maximum source ring vertices admitted across all land polygons. */
export const MAX_SOURCE_VERTICES = 1_000_000
/** Maximum bake mesh vertices (coastline corners, interior lattice, cities and fixed-link landfalls). */
export const MAX_MESH_VERTICES = 1_000_000
/** Maximum shipped cities the bake will attach and route. */
export const MAX_BAKED_CITIES = 4096
/**
 * Lane budget as a MEAN per city: at most this many lanes × the city count in total (one city may have more). Lanes
 * are the adjacency of connected land regions, a planar graph, so Euler's bound (edges ≤ 3 × vertices − 6 per
 * component) caps them; more lanes than this means the regions are corrupt.
 */
export const MAX_MEAN_LANES_PER_CITY = 3
/** Maximum cumulative route control points across every emitted lane. */
export const MAX_BAKED_CONTROL_POINTS = 65_536
/** Maximum serialized navigation document size. */
export const MAX_NAVIGATION_DOCUMENT_BYTES = 4 * 1024 * 1024
/** Maximum distance an offshore city may be moved onto land. */
export const MAX_CORRECTION_METRES = 100
/** How far inside the land triangle an attached city is inset. */
export const INSET_METRES = 10

/** Maximum cumulative route control points across one match's land links (PathService.landLinks: the setup's edges). */
export const MAX_MATCH_ROUTE_POINTS = 131_072
/** Byte budget for one war's COMPLETE setup DTO; the setup-view producer checks a conservative msgpack bound. */
export const SETUP_PAYLOAD_BUDGET_BYTES = 8 * 1024 * 1024
